import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { saveThumbnail } from '@/api/project';
import { handleError } from '@/actions/common';
import { saveImplicitProjectThumbnails } from '../client';
import Compressor from 'compressorjs';
import { Vector3d } from '@bimdata/definitions/types';

async function trimHash(hash: string): Promise<string> {
  if (hash.length < 128) return hash;
  const buf = new TextEncoder().encode(hash);
  const digest = await crypto.subtle.digest('SHA-512', buf);
  return Array.from(new Uint8Array(digest))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export default async (projectId: string, origin: Blob, position: Vector3d, direction: Vector3d, models: number[]) => {
  try {
    const enc = new TextEncoder();
    let preHash = '';
    for (let n of enc.encode(projectId)) {
      preHash += n.toString(16);
    }

    for (let m of models.sort()) {
      const tmp = new DataView(new ArrayBuffer(4));
      tmp.setInt32(0, m);
      let v = '';
      for (let n of (new Uint8Array(tmp.buffer))) {
        if (n > 0 || v) v += n.toString(16);
      }
      preHash += v;
    }

    const view = new DataView(new ArrayBuffer(4 * 6));
    view.setFloat32(0 * 4, position.x);
    view.setFloat32(1 * 4, position.y);
    view.setFloat32(2 * 4, position.z);
    view.setFloat32(3 * 4, direction.x);
    view.setFloat32(4 * 4, direction.y);
    view.setFloat32(5 * 4, direction.z);

    for (let n of new Uint8Array(view.buffer)) {
      preHash += n.toString(16).padStart(2, '0');
    }

    const originHash = await trimHash(preHash + '0');
    const smallHash = await trimHash(preHash + '1');
    const tinyHash = await trimHash(preHash + '2');

    const small = await new Promise<Blob>((resolve, reject) => {
      new Compressor(origin, {
        maxWidth: 800,
        maxHeight: 800,
        success: resolve,
        error: reject,
      });
    });
    const tiny = await new Promise<Blob>((resolve, reject) => {
      new Compressor(origin, {
        maxWidth: 300,
        maxHeight: 300,
        success: resolve,
        error: reject,
      });
    });

    await saveThumbnail(projectId, originHash, origin);
    await saveThumbnail(projectId, smallHash, small);
    await saveThumbnail(projectId, tinyHash, tiny);

    saveImplicitProjectThumbnails(projectId, {
      models: models.length,
      origin: originHash,
      small: smallHash,
      tiny: tinyHash
    });

    store.dispatch(projectSlice.actions.thumbnailIdle({
      projectId,
      source: URL.createObjectURL(small),
    }));
  } catch (error) {
    handleError(error);
    throw error;
  }
};